import React from 'react'
import { Redirect } from 'react-router-dom'

import Header from './Header'
import ProgramsList, { shouldDisplayProgram } from './ProgramsList'
import { buildLocationsUrl } from '../app/routes-urls'

const Programs = ({
  programs,
  locationId,
  date,
  user,
  config,
  showCountSyncBanner,
  showShipmentSyncBanner
}) => {
  const hasPrograms = programs && programs.length
  const displayedPrograms = programs.filter(shouldDisplayProgram)

  if (!hasPrograms) {
    return <span>No programs found</span>
  }

  if (displayedPrograms.length === 1) {
    const [program] = displayedPrograms
    const shouldAutoOpenProgram = !program.isOverviewLoading && !program.isExternal
    if (shouldAutoOpenProgram) {
      return <Redirect to={buildLocationsUrl({ locationId, date, programId: program.id })} />
    }
  }

  return (
    <div className='program-selection'>
      <Header
        config={config}
        title='Stock reporting for all programs'
        user={user}
      />
      <main className='program-selection__programs'>
        <ProgramsList
          programs={programs}
          locationId={locationId}
          date={date}
          showCountSyncBanner={showCountSyncBanner}
          showShipmentSyncBanner={showShipmentSyncBanner}
        />
      </main>
    </div>
  )
}

export default Programs
